import { render, staticRenderFns } from "./DropzoneFiles.vue?vue&type=template&id=5df832b0&scoped=true&"
import script from "./DropzoneFiles.vue?vue&type=script&lang=ts&"
export * from "./DropzoneFiles.vue?vue&type=script&lang=ts&"
import style0 from "./DropzoneFiles.vue?vue&type=style&index=0&id=5df832b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df832b0",
  null
  
)

export default component.exports